import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getTipsList (params) { // 获取提示列表
    return axios.post(global.CMS_TIPS + '/findAllTips', params)
  },
  getTipsDetail (params) { // 获取提示详情
    return axios.post(global.CMS_TIPS + '/findTipsContentByTipsId', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/cms/tips.js